<template>
  <div v-show="showComponent" class="object-dashboard">
    <!-- Sub Navbar -->
    <v-app-bar
        app
        clipped-left
        clipped-right
        class="mt-16 sub-app-bar"
        fixed
    >
      <v-row align="center">
        <v-col cols="1" md="4" lg="3">
          <div class="d-flex flex-row">
            <div v-if="visible">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs}">
                  <v-btn icon
                         @click="$router.push(getBuildingPath())" v-bind="attrs" v-on="on">
                    <v-icon>home</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('common:building')}}</span>
              </v-tooltip>
            </div>

            <!-- Bar Title -->
            <div v-if="$vuetify.breakpoint.mdAndUp">
              <p class="title">
                <v-tooltip v-if="facility.cutName" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ facility.cutName }}
                    </span>
                  </template>
                  {{ facility.name }}
                </v-tooltip>
                <span v-else>{{ facility.name }}</span>
              </p>
              <p class="subtitle">{{ tabName }}</p>
            </div>
            <div v-else-if="$vuetify.breakpoint.lgAndUp">
              <p class="title">{{ facility.name }}</p>
              <p class="subtitle">{{ tabName }}</p>
            </div>

          </div>
        </v-col>

        <!-- Bar Tab Links -->
        <v-col cols="10" sm="9" md="6" lg="6">
          <div class="d-flex flex-row">
            <v-tabs
                v-model="currentTab"
                hide-slider
            >
              <v-tab :to="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/dashboard`">
                <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('common:dashboard')}}</span>
                <span v-else><v-icon>dashboard</v-icon></span>
              </v-tab>
              <v-tab :to="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id }/activities`">
                <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('common:activity_plural')}}</span>
                <span v-else><v-icon>event_note</v-icon></span>
              </v-tab>
              <v-tab :to="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/processes`">
                <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('common:process_plural')}}</span>
                <span v-else><v-icon>line_weight</v-icon></span>
              </v-tab>
              <!-- TODO uncomment when communication is implemented -->
              <!-- <v-tab to="#communication">
                <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('book/facility:facility.communication')}}</span>
                <span v-else><v-icon>chat_bubble</v-icon></span>
              </v-tab> -->
              <v-tab :to="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info`">
                <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('book/facility:common.facility-info')}}</span>
                <span v-else><v-icon>apartment</v-icon></span>
              </v-tab>
              <v-tab :to="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/cost-analysis`">
                <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('book/facility:cost-analysis.cost-analysis')}}</span>
                <span v-else><v-icon>payments</v-icon></span>
              </v-tab>
              <v-tab v-if="facility && facility.displayId"
                     :to="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/emergency`">
                <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('book/facility:emergency.emergency')}}</span>
                <span v-else><v-icon>local_hospital</v-icon></span>
              </v-tab>
            </v-tabs>
          </div>
        </v-col>

        <!-- Current Date -->
        <v-col class="d-none d-lg-flex"></v-col>
        <v-col cols="1" sm="2" md="2" xl="1" class="text-right d-none d-sm-flex">
          <p class="mb-0 pb-0 grey--text ml-auto">
            <v-icon color="grey">calendar_today</v-icon>
            {{ currentDate }}
          </p>
        </v-col>
      </v-row>
    </v-app-bar>

    <FacilityFormSidebar
        ref="formSidebar"
    />

    <!-- Page Content -->
    <div class="facility-content-wrapper">
      <v-tabs-items v-model="currentTab">
        <!-- Dashboard Tab -->
        <v-tab-item
            :value="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/dashboard`"
            class="pa-3 pa-sm-5"
            eager
        >
          <FacilityDashboardTab
              ref="dashboardTab"
              @docuQuickLink="$refs.infoTab.addDocu()"
              @roleQuickLink="$refs.infoTab.addRole()"
              @processQuickLink="$refs.infoTab.addProcess()"
          />
        </v-tab-item>

        <!-- Activity Tab -->
        <v-tab-item
            :value="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/activities`"
            class="pa-3 pa-sm-5"
        >
          <FacilityActivityTab />
        </v-tab-item>

        <!-- Processes Tab -->
        <v-tab-item
            :value="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/processes`"
            eager
            class="pa-3 pa-sm-5"
        >
          <FacilityProcessTab

              ref="processTab"
          />
        </v-tab-item>

        <!-- Communication Tab -->
        <!-- TODO uncomment and implement when communication is available
        <v-tab-item
            value="communication"
            eager
            class="pa-6"
        >
          TODO add communication component
        </v-tab-item> -->

        <!-- Facility-Info Tab -->
        <v-tab-item
            :value="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info`"
            class="pa-3 pa-sm-5"
            eager
        >
          <FacilityInfoTab
              ref="infoTab"
              @updateQuicklinkContracts="getContracts"
              @updateQuicklinkDocus="getDocumentations"
              @updateQuicklinkProcesses="getProcessJobs"
              @updateQuicklinkRoles="getRoles"
              @updateDocuScore="$refs.dashboardTab.docuScore = $event"
              @updateRoleScore="$refs.dashboardTab.roleScore = $event"
          />
        </v-tab-item>

        <!-- Cost analysis -->
        <v-tab-item
            :value="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/cost-analysis`"
            class="pa-3 pa-sm-5"
            eager
        >
          <FacilityCostAnalysisTab
              ref="facilityCostAnalysisTab"
          />
        </v-tab-item>

        <!-- Emergency tab -->
        <v-tab-item
            :value="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/emergency`"
            class="pa-3 pa-sm-5"
            eager
            v-if="facility && facility.displayId"
        >
          <EmergencyOverview
              ref="emergencyOverview"
              :elevator-id="facility.displayId"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>

    <FacilityQuickLinkSidebar
        ref="quicklinkSidebar"
        @viewDocument="$refs.infoTab.viewDocument($event)"
        @docuQuickLink="$refs.infoTab.addDocu()"
        @roleQuickLink="$refs.infoTab.addRole()"
        @processQuickLink="$refs.infoTab.addProcess()"
        @contractQuickLink="$refs.infoTab.addContract()"
    />
  </div>
</template>
<script>

import BuildingService from '@/modules/book/services/building-service';
import FacilityService from '@/modules/book/services/facility-service';
import FacilityUserAssignmentService from '@/modules/book/services/facility-user-assignment-service';
import DocumentationService from '@/modules/core/services/documentation-service';
import ProcessJobService from '@/modules/book/services/process/impl/process-job-service'
import ContractInfoService from '@/modules/book/services/contract-info-service';

import Utils from '@/modules/core/services/utils';
import DataUtils from '@/modules/core/services/data-utils';

import Building from '@/modules/book/data/building';
import Facility from '@/modules/book/data/facility';
import FacilityUserAssignment from '@/modules/book/data/facility-user-assignment';
import ProcessJob from '@/modules/book/data/processJob'

import FacilityFormSidebar from './FacilityFormSidebar'
import FacilityQuickLinkSidebar from './FacilityQuickLinkSidebar'

import FacilityCostAnalysisTab from '@/modules/book/views/cost-analysis/facility/FacilityCostAnalysisTab';
import FacilityDashboardTab from './tabs/FacilityDashboardTab'
import FacilityActivityTab from './tabs/FacilityActivityTab'
import FacilityProcessTab from './tabs/FacilityProcessTab'
import FacilityInfoTab from './tabs/FacilityInfoTab'

import {mapState} from 'vuex';
import DateUtils from '@/modules/core/services/date-utils';
import CustomerService from '@/modules/core/services/customer-service';
import Customer from '@/modules/core/data/customer';
import EmergencyOverview from '@/modules/display/views/emergency/EmergencyOverview';

export default {
  name: 'FacilityDashboard',
  components: {
    EmergencyOverview,
    FacilityFormSidebar,
    FacilityQuickLinkSidebar,
    FacilityDashboardTab,
    FacilityActivityTab,
    FacilityProcessTab,
    FacilityInfoTab,
    FacilityCostAnalysisTab
  },
  data() {
    return {
      facility: new Facility(),
      building: new Building(),
      currentDate: null,
      currentTab: null,

      isFetchingFacility: true,
      isFetchingBuilding: true,
      isFetchingDocus: true,
      isFetchingRoles: true,
      isFetchingProcesses: true,
      isFetchingContracts: true,
      loggedInCustomer: null,
    }
  },
  computed: {
    visible() {

      if (this.isFetchingBuilding)
        return false;

      if (this.isAdmin)
        return true;

      if (!this.isOperator)
        return false;

      if (this.loggedInCustomer !== null) {
        if (Utils.checkCustomerWithDescendentsForBuilding(this.loggedInCustomer, this.building)) {
          return true;
        }
      }
      return false;
    },
    isManager() {
      return this.$store.getters['auth/isManager'];
    },
    isAdmin() {
      return this.$store.getters['auth/isAdmin'];
    },
    isOperator() {
      return this.$store.getters['auth/isOperator'];
    },
    eventLogTypes() {
      return [
        {text: this.$t("common:all"), value: "ALL"},
        {text: this.$t("common:user"), value: "USER"},
        {text: this.$t("common:process"), value: "PROCESS"},
        {text: this.$t("common:document"), value: "DOCUMENT"},
        {text: this.$t("common:facility"), value: "FACILITY"},
      ];
    },

    ...mapState('book/layout', {
      leftFacilityDrawer: state => state.leftFacilityDrawer,
      rightFacilityDrawer: state => state.rightFacilityDrawer
    }),

    showComponent() {
      if(this.isFetchingFacility && this.isFetchingBuilding && this.isFetchingDocus && this.isFetchingRoles
          && this.isFetchingProcesses && this.isFetchingContracts) {
        return false
      } else {
        return true;
      }
    },

    // returns current tab name
    tabName() {
      if(this.$route.name === 'FacilityDashboardTab') {
        return this.$t('common:dashboard')
      } else if(this.$route.name === 'FacilityActivityTab') {
        return this.$t('common:activity_plural')
      } else if(this.$route.name === 'FacilityProcessTab') {
        return this.$t('common:process_plural')
      } else {
        return this.$t('book/facility:common.facility-info')
      }
    }
  },
  methods: {
    getBuildingPath() {
      let ret = `/${this.$store.state.manager.bookModuleUrl}/buildings/edit/` + this.building.id + `#facilities`
      return ret;
    },
    getRoles() {
      FacilityUserAssignmentService.readFacilityUserAssignmentsForFacility(this.$route.params.id,
        (res) => {
          this.restRole = DataUtils.parseDataToObjectArray(res.data, FacilityUserAssignment);

          // sort by userName
          this.restRole.sort((a, b) => {
            if(a.userName < b.userName) {
              return -1;
            }

            if(a.userName > b.userName) {
              return 1;
            }

            return 0;
          })
          this.$refs.quicklinkSidebar.restRoles = this.restRole;
          this.isFetchingRoles = false;
        },
        (error) => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/facility:facility.snackbar.assignment')}))
          this.$logger.error("Error at fetching facility user assignments: " + error);
        }
      );
    },

    getDocumentations() {
      DocumentationService.readPageableFacilityDocumentationsFromAPI(this.$route.params.id, 0, -1, '', '', 'ALL', ['name'], [false],
        (res) => {
          res.data.content.forEach((document) => {
            document.type = this.$t('enums:facility-documentation-types.' + document.type)
          })
          this.$refs.quicklinkSidebar.restDocus = res.data.content;
          this.isFetchingDocus = false;
        },
        (error) => {
          this.$logger.info("Error at fetching facility documentations: " + error);
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/facility:facility.snackbar.facility-documents')}))
        }
      )
    },

    getProcessJobs() {
      ProcessJobService.readPageableFacilityProcessJobFromAPI(this.$route.params.id, 0, -1, '', ['processName'], [false],
        (res) => {
          this.$refs.quicklinkSidebar.restProcesses = DataUtils.parseDataToObjectArray(res.data.content, ProcessJob);
          this.isFetchingProcesses = false;
        },
        (error) => {
          this.$logger.info("Error at fetching facility processes: " + error);
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/facility:facility.snackbar.facility-processes')}))
        }
      )
    },

    getContracts() {
      ContractInfoService.readAllPaginatedFromAPI(this.$route.params.id, 0, -1, '', ['name'], [false],
        (res) => {
          this.$refs.quicklinkSidebar.restContracts = res.data.content;
          this.isFetchingContracts = false;
        },
        (error) => {
          this.$logger.error("Error at fetching facility contracts: " + error);
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:contract_plural')}))
        }
      )
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {

      if(from.hash) {
        vm.$store.commit('book/routes/storeLastMainRoute', from.path + from.hash);
      } else {
        vm.$store.commit('book/routes/storeLastMainRoute', from.path);
      }

      // open docu dialog if according action btn was clicked in facilities overview
      if((to.name === 'FacilityDocuInfoTab' && from.name === 'FacilityOverview')
          || (to.name === 'FacilityDocuInfoTab' && from.name === 'AddEditBuilding')) {
        vm.$refs.infoTab.addDocu();
      }

      // open docu dialog if according action btn was clicked in facilities overview
      if((to.name === 'FacilityContractInfoTab' && from.name === 'FacilityOverview')
          || (to.name === 'FacilityContractInfoTab' && from.name === 'AddEditBuilding')) {
        vm.$refs.infoTab.addContract();
      }

      // open docu dialog if according action btn was clicked in facilities overview
      if((to.name === 'FacilityProcessInfoTab' && from.name === 'FacilityOverview')
          || (to.name === 'FacilityProcessInfoTab' && from.name === 'AddEditBuilding')) {
        vm.$refs.infoTab.addProcess();
      }
    });
  },
  created() {

    FacilityService.readFromAPI(this.$route.params.id,
      (res) => {
        this.facility = DataUtils.parseDataToSingleObject(res.data, Facility);

        //this.facility.cutName = Utils.cropText(this.facility.name, 10, false)
        if(this.facility.name.length > 20) {
          this.facility.cutName = Utils.cropText(this.facility.name, 20, false)
        }

        BuildingService.readBasicFromAPI(this.facility.building, this.facility.id,
          (res) => {
            this.building = DataUtils.parseDataToSingleObject(res.data, Building);
            this.isFetchingBuilding = false;
            CustomerService.readProfileFromAPI(
                (response) => {
                  this.loggedInCustomer = DataUtils.parseDataToSingleObject(response.data, Customer);
                  this.$refs.formSidebar.setFacilityFormSidebarData(this.facility, this.building, this.loggedInCustomer);
                }
            );

          },
          (error) => {
            this.$logger.error(error);
          }
        )

        this.getRoles();
        this.getDocumentations();
        this.getProcessJobs();
        this.getContracts();

        this.isFetchingFacility = false;
      },
      (error) => {
        this.$logger.info("Error at fetching specific building: " + error);
        this.$router.push('/403');
      }
    )

    this.currentDate = DateUtils.getCurrentDateAsDEString();
  }
}
</script>